import { $enum } from 'ts-enum-util';
import { mixed as yupMixed, MixedSchema } from 'yup';
import { protoEnumKeys } from './ProtoEnumKeys';

export interface IValueEnumAndType {
	valueEnum?: any;
	withUnspecified?: boolean;
	required?: boolean;
}

export const yupEnum = ({ required = false, valueEnum, withUnspecified = false }: IValueEnumAndType = {}): MixedSchema => {
	const possibleValues = valueEnum ? $enum(valueEnum).getValues() : [];

	if (!required) {
		possibleValues.push(null);
	}

	let validation = yupMixed()
		.oneOf(possibleValues, `Value must be of type: ${protoEnumKeys(valueEnum, { withUnspecified }).join(', ')}`)
		.strict(true)
		.nullable();

	if (required) {
		validation = validation.required(`required field`); // TODO: use commonMessages.required()
	}

	return validation;
};
